/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Wczytanie produktów z URL + wygenerowanie HTML
 * * Obiekt musi być zadeklarowany po załadowaniu DOM
 *
 * @export
 * @class CreatePVIHtmlFromJSON
 */

export class CreatePVIHtmlFromJSON {
	constructor(options) {
		var defaultSettings = {
			triggerTarget: null,
			JSONUrl: null,
			showPromoPrice: true,
			brunetto: false,
			onPVIReady: function () { }
		};
		this.settings = $.extend({}, defaultSettings, options);
		this.JSON = null;
		this.moduleScheme = null;
		this.productScheme = null;
		this.shipmentSheme = null;
		this.alertTrigger = false;
		this.switchAlertTrigger = false;
		this.TDTimer = false;
		this.init();
	}
	// ****************************************************************************************************
	// Inicjalizacja modulu PVI
	// ****************************************************************************************************
	init() {
		var that = this;
		if (that.settings.triggerTarget !== null && that.settings.JSONUrl !== null) {
			that.mainCont = $('#' + that.settings.triggerTarget);
			that.loadJSON();
		}
	}
	// ****************************************************************************************************
	// Pobranie danych do modulu
	// ****************************************************************************************************
	loadJSON() {
		var that = this;
		var JSONTmpCont = that.settings.triggerTarget + '_JSONData';
		$('<div/>', { 'id': JSONTmpCont, 'class': 'd-none' }).appendTo('#' + that.settings.triggerTarget);
		toolsObj.ajaxLoadData({
			forceAjaxPageLoad: true,
			updateBrowserHistory: false,
			url: that.settings.JSONUrl,
			target: '#' + JSONTmpCont,
			loadingMode: false,
			dataType: 'JSON',
			getDataMode: true,
			sourceOfError: 'CreatePVIHtmlFromJSON::loadJSON',
			onError: function () {
				that.mainCont.remove();
			},
			getData: function (data, target) {
				if ( data !== undefined ) {
					that.JSON = data;
					that.createPVIModule();
				} else {
					that.mainCont.remove();
					loggerObj.addCustomError('JSON data is undefined -> '+that.settings.triggerTarget, 'CreatePVIHtmlFromJSON::loadJSON');
				}
			},
			onComplete: function () {
				$('#' + JSONTmpCont).remove();
			}
		});
	}
	// ****************************************************************************************************
	// Utworzenie modułu PVI ze schematu
	// ****************************************************************************************************
	createPVIModule() {
		//console.log('createPVIModule');
		var that = this;
		var moduleSchemeTmpCont = that.settings.triggerTarget + '_moduleScheme';
		$('<div/>', { 'id': moduleSchemeTmpCont }).appendTo('#' + that.settings.triggerTarget);
		toolsObj.ajaxLoadData({
			updateBrowserHistory: false,
			url: '/stat/schemat-PVI-moduleScheme',
			target: '#' + moduleSchemeTmpCont,
			loadingMode: false,
			getDataMode: true,
			sourceOfError: 'CreatePVIHtmlFromJSON::createPVIModule',
			onError: function () {
				that.mainCont.remove();
			},
			getData: function (data) {
				if ( data !== undefined ) {
					that.moduleScheme = data;
					$('#' + moduleSchemeTmpCont).html(that.adjustModuleSchame(that.moduleScheme));
					$('#' + that.settings.pviModuleID).appendTo('#' + that.settings.triggerTarget);
					that.createPVIProductScheme();
					$('#' + moduleSchemeTmpCont).remove();
				} else {
					that.mainCont.remove();
					loggerObj.addCustomError('PVI-moduleScheme data is undefined -> '+that.settings.triggerTarget, 'CreatePVIHtmlFromJSON::createPVIModule');
				}
			}
		});
	}
	// ****************************************************************************************************
	// Uzupełnienie schematu danymi modułu
	// ****************************************************************************************************
	adjustModuleSchame(data) {
		var that = this;
		var size = that.getProductCountFromJASON();
		var sizeNew = size;
		if (that.settings.JSONRoot == 'TowaryPromo') {
			for (let i = 0; i < size; i++) {
				if (TODAYS_DEALS_EXCLUSIONS.includes(that.JSON[that.settings.JSONRoot][i].id)) {
					sizeNew = sizeNew - 1;
				}
			}
		}
		return data.replace(/moduleID/g, that.settings.pviModuleID).replace('$cfgModuleIDProductsCount', sizeNew);
	}
	// ****************************************************************************************************
	// Wyznaczenie ilości productów w JSON
	// ****************************************************************************************************
	getProductCountFromJASON() {
		var that = this;
		var size = that.JSON[that.settings.JSONRoot].length;
		return size;
	}
	// ****************************************************************************************************
	// Utworzenie schematu produktu w PVI
	// ****************************************************************************************************
	createPVIProductScheme() {
		//console.log('createPVIProductScheme');
		var that = this;
		var productSchemeTmpCont = that.settings.triggerTarget + '_productScheme';
		$('<div/>', { 'id': productSchemeTmpCont }).appendTo('#' + that.settings.triggerTarget);
		toolsObj.ajaxLoadData({
			updateBrowserHistory: false,
			url: '/stat/schemat-PVI-productScheme',
			target: '#' + productSchemeTmpCont,
			loadingMode: false,
			getDataMode: true,
			sourceOfError: 'CreatePVIHtmlFromJSON::createPVIProductScheme',
			onError: function () {
				that.mainCont.remove();
			},
			getData: function (data) {
				if ( data !== undefined ) {
					that.productScheme = that.adjustProductSchame(data);
					that.injectJSONToPVIModule();
					$('#' + productSchemeTmpCont).remove();
					$('#' + that.settings.triggerTarget + ' .loading').remove();
					that.checkIsOutlet();
					if ( SHOW_FORBIDDEN_BADGE_ON_MAIN_PAGE ) {
						that.checkForbiddenProducts();
					}
					that.settings.onPVIReady.call();
					that.mainCont.removeClass('emptyJSONContainer');

					if ( TD_TIMER_SWITCH && that.TDTimer !== false && that.settings.JSONRoot == 'TowaryPromo' ) {
						$('<p class="promoTimerLabel pl-2 pl-xl-0">'+TD_TIMER_LABEL+'</p><p class="promoTimer h2 px-2 px-xl-0" data-time-left="'+that.TDTimer+'" data-timer-mode="'+TD_TIMER_MODE+'" data-display-mode="tabs">&nbsp;</p>').insertAfter("#addTodaysDeals .bottomLine");
						toolsObj.addPromoCounter();
					}
				} else {
					that.mainCont.remove();
					loggerObj.addCustomError('PVI-productScheme data is undefined -> '+that.settings.triggerTarget, 'CreatePVIHtmlFromJSON::createPVIProductScheme');
				}
			}
		});
	}
	// ****************************************************************************************************
	// Sprawdzanie, czy tylko dzisiaj jest w trybie OUTLET (czyli wszystkie pozycje są outletowe)
	// ****************************************************************************************************
	checkIsOutlet() {
		var that = this;
		var isOutlet = true;
		for (let i = 1; i <= that.getProductCountFromJASON(); i++) {
			if (!that.JSON[that.settings.JSONRoot][i - 1].wyprzedaz)
				isOutlet = false;
		}
		if (isOutlet)
			$('#addTodaysDeals h2 a').html(TXT_OUTLET_NAME).attr('title', TXT_OUTLET_TITLE);
	}


	// ****************************************************************************************************
	// Sprawdzanie, czy towat zabroniony
	// ****************************************************************************************************
	checkForbiddenProducts() {
		var that = this;
		var salesForbiddenBadge = '<div class="individualPriceInfo individualPriceInfoT mb-0 small">' + TXT_SALES_FORBIDDEN + '</div>';

		for (let i = 1; i <= that.getProductCountFromJASON(); i++) {
			if (that.JSON[that.settings.JSONRoot][i - 1].zabroniony) {
				let id = that.settings.pviModuleID.slice(0, -1)+"-"+i;
				$("#"+id+" .productPrice").html(salesForbiddenBadge);
			}
		}
	}


	// ****************************************************************************************************
	// Uzupełnienie schematu danymi modułu
	// ****************************************************************************************************
	adjustProductSchame(data) {
		var that = this;
		// kolejność ma zanczenie
		data = data.replace(/\$ampvi_single_box_label/g, that.settings.pviModuleBoxClass);
		data = data.replace('img$ampvi_label', 'img' + that.settings.pviModuleID.charAt(0).toUpperCase() + that.settings.pviModuleID.slice(1));
		data = data.replace(/\$ampvi_label/g, that.settings.pviModuleID);
		data = data.replace('alt="$towar.nazwa - $towar.kod"', 'alt="__markerImgAlt__"');
		data = data.replace('$plCfgImageTitle', '__markerImgTitle__');
		data = data.replace(/title="\$towar.kod - \$towar.nazwa"/g, 'title="__markerProductTitle__"');
		data = data.replace('name="zabroniony" value="N"', 'name="zabroniony" value="__markerInput_zabroniony__"');
		data = data.replace('name="zapowiedz" value="N"', 'name="zapowiedz" value="__markerInput_zapowiedz__"');
		return data;
	}
	// ****************************************************************************************************
	// Tworzy karty produktów na podstawie JSON i schematu produktu
	// ****************************************************************************************************
	injectJSONToPVIModule() {
		var that = this;
		var productHtml;
		for (let i = 1; i <= that.getProductCountFromJASON(); i++) {
			if (that.settings.JSONRoot != 'TowaryPromo' || (that.settings.JSONRoot == 'TowaryPromo' && !TODAYS_DEALS_EXCLUSIONS.includes(that.JSON[that.settings.JSONRoot][i - 1].id))) {
				if ( that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0] === undefined ) { // uzupełnienie danych gdy brak IMG
					that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista = [{alt: "No image", nazwa: 'no-img', title: 'No image', typ: ".gif"}];
				}

				if ( TD_TIMER_SWITCH && that.TDTimer === false && that.settings.JSONRoot == 'TowaryPromo' ) {
					that.TDTimer = that.JSON[that.settings.JSONRoot][i - 1].czas_promo_sek;
				}

				var ukryteOdpowiedniki = (that.JSON[that.settings.JSONRoot][i - 1].odpowiedniki2) ? that.JSON[that.settings.JSONRoot][i - 1].odpowiedniki2 : "empty"; // false wysypuje inludes

				productHtml = that.productScheme;
				productHtml = productHtml.replace('$foreach.count', i);
				productHtml = productHtml.replace(/\$towar.id/g, that.JSON[that.settings.JSONRoot][i - 1].id);
				productHtml = productHtml.replace(/\$\{towar.id\}/g, that.JSON[that.settings.JSONRoot][i - 1].id);

				that.settings.brunetto = false;
				if ( productHtml.includes('__markerBrunetto__') && that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "J" ) {
					productHtml = productHtml.replace('__markerBrunetto__', '');
					that.settings.brunetto = true;
				}

				if ( that.settings.pviModuleBoxClass == "newProduct" ) { // nowosci
					productHtml = productHtml.replace(/\$towar.kod/g, NEW_ADDON + that.JSON[that.settings.JSONRoot][i - 1].kod);
				} else if (that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "PRO" ) {
					if ( ukryteOdpowiedniki.includes('so2022OFF') ) {
						productHtml = productHtml.replace(/\$towar.kod/g, CODE_ADDON_PROMO + that.JSON[that.settings.JSONRoot][i - 1].kod);
					} else {
						productHtml = productHtml.replace(/\$towar.kod/g, CODE_ADDON_TD + that.JSON[that.settings.JSONRoot][i - 1].kod);
					}
				} else if (that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "J" ) {
					productHtml = productHtml.replace(/\$towar.kod/g, CODE_ADDON_JOKER + that.JSON[that.settings.JSONRoot][i - 1].kod);
				} else {
					productHtml = productHtml.replace(/\$towar.kod/g, that.JSON[that.settings.JSONRoot][i - 1].kod);
				}

				productHtml = productHtml.replace(/\$towar.nazwa/g, that.JSON[that.settings.JSONRoot][i - 1].nazwa);
				productHtml = productHtml.replace(/\$towar.url/g, that.JSON[that.settings.JSONRoot][i - 1].url);
				productHtml = productHtml.replace(/\$towar.jm/g, that.JSON[that.settings.JSONRoot][i - 1].jm);
				productHtml = productHtml.replace(/\$towar.dokladnosc/g, that.JSON[that.settings.JSONRoot][i - 1].dokladnosc);

				if (that.JSON[that.settings.JSONRoot][i - 1].koszyk_count != 0)
					productHtml = productHtml.replace(/\$towar.koszyk_count/g, that.JSON[that.settings.JSONRoot][i - 1].koszyk_count);
				else
					productHtml = productHtml.replace(/\$towar.koszyk_count/g, '');

					if (that.JSON[that.settings.JSONRoot][i - 1].title) {
					productHtml = productHtml.replace(/__markerProductTitle__/g, toolsObj.encodeHtmlEntities(that.JSON[that.settings.JSONRoot][i - 1].title));
				} else {
					productHtml = productHtml.replace(/__markerProductTitle__/g, toolsObj.encodeHtmlEntities(that.JSON[that.settings.JSONRoot][i - 1].kod + ' - ' + that.JSON[that.settings.JSONRoot][i - 1].nazwa));
				}

				if (that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].nazwa) {
					productHtml = productHtml.replace('__markerImgName__', that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].nazwa + that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].mime);
				} else {
					productHtml = productHtml.replace('__markerImgName__', toolsObj.formatImageName(that.JSON[that.settings.JSONRoot][i - 1].kod + ' - ' + that.JSON[that.settings.JSONRoot][i - 1].nazwa, that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].mime)); // brak rozszerzenia nie blokuje wyświetlania --- that.JSON[that.settings.JSONRoot][i-1].obrazy_lista[0].mime
				}

				if (that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].title) {
					productHtml = productHtml.replace('__markerImgTitle__', that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].title);
				} else {
					productHtml = productHtml.replace('__markerImgTitle__', that.JSON[that.settings.JSONRoot][i - 1].nazwa);
				}

				if (that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].alt) {
					productHtml = productHtml.replace('__markerImgAlt__', that.JSON[that.settings.JSONRoot][i - 1].obrazy_lista[0].alt);
				} else {
					productHtml = productHtml.replace('__markerImgAlt__', that.JSON[that.settings.JSONRoot][i - 1].nazwa + ' - ' + that.JSON[that.settings.JSONRoot][i - 1].kod);
				}

				if (that.JSON[that.settings.JSONRoot][i - 1].zabroniony) {
					productHtml = productHtml.replace('__markerInput_zabroniony__', 'T');

				} else {
					productHtml = productHtml.replace('__markerInput_zabroniony__', 'N');
				}

				if (that.JSON[that.settings.JSONRoot][i - 1].zapowiedz) {
					productHtml = productHtml.replace('__markerInput_zapowiedz__', 'T');
				} else {
					productHtml = productHtml.replace('__markerInput_zapowiedz__', 'N');
				}

				productHtml = that.createShipmentHtml(productHtml, i);

				if ( productHtml.includes('__markerPriceHidden__') ) {
					productHtml = productHtml.replace('__markerPriceHidden__', HIDDEN_PRICE_ADDON);
				} else if ( that.settings.brunetto ) {
					productHtml = productHtml.replace('__markerProductPrice__', that.createBrunettoPriceHtml(i));
				} else if ( that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "J" ) {
					productHtml = productHtml.replace('__markerProductPrice__', that.createJokerPriceHtml(i));
				} else if ( that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "PRO" || that.settings.triggerTarget == "addTodaysDeals" ) { // zmienione 13.02.2023 - kafelki w bestsellerach maja oznaczenie PRO ale nie wylicza dobrze wysokosci
			//	} else if ( that.settings.triggerTarget == "addTodaysDeals" ) {
					productHtml = productHtml.replace('__markerProductPrice__', that.createPromoPriceHtml(i));
				} else {
					productHtml = productHtml.replace('__markerProductPrice__', that.createPriceHtml(i));
				}

				productHtml = productHtml.replace('__markerProductAvailability__', that.createAvailabilityHtml(i));
				$('#' + that.settings.pviModuleID + 'Row').append(productHtml);
				if (that.settings.JSONRoot == 'TowaryPromo') {
					if ( that.JSON[that.settings.JSONRoot][i - 1].wyprzedaz && ukryteOdpowiedniki.includes('outlet') ) {
						that.adjustHtmlToOutletProduct($('#p-todaysDeals-' + that.JSON[that.settings.JSONRoot][i - 1].id), that.JSON[that.settings.JSONRoot][i - 1].stan_mag, that.JSON[that.settings.JSONRoot][i - 1].cena_kth_netto, that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto, that.JSON[that.settings.JSONRoot][i - 1].stan_mag);
					} else if (that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "J" ) {
						that.addJokerBadge(i);
					} else {
						that.addPercentBadge($('#p-todaysDeals-' + that.JSON[that.settings.JSONRoot][i - 1].id), that.JSON[that.settings.JSONRoot][i - 1].cena_kth_netto, that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto, '', '/todays-deals', '');
					}
				} else if (that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "PRO" ) {
					if ( ukryteOdpowiedniki.includes('so2022OFF') ) {
						that.addSOBadge(i);
					} else {
						that.addPercentageBadge(i);
					}
				} else if (that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ == "J" ) {
					that.addJokerBadge(i);
				} else if ( DELIVERY_ON_VACATION ) {
					that.addFreeDeliveryBadge(i);
				}

				// usunięte dodawanie do koszyka z głównej - zebranie 18.09.2023
				$('#p-' + that.settings.pviModuleID + '-' + that.JSON[that.settings.JSONRoot][i - 1].id).find('.productAddToCart').remove();
			}
		}
		if ( that.switchAlertTrigger && that.alertTrigger ) {
			$.get('/info/ajax/outletSoldOutNotification.php'); // ToDo: dorobić wysyanie listy towarów
		}
	}
	// ****************************************************************************************************
	// Przerobienie na kafelek outletowy
	// ****************************************************************************************************
	adjustHtmlToOutletProduct(obj, quantity, kth_net, es_netto, stan_mag) {
		var that = this;
		obj.addClass('pvi_module_outlet');
		obj.find('.atc_quantity').data('limit-quantity',stan_mag);
		that.addPercentBadge(obj, kth_net, es_netto, 'outletPercent', OUTLET_HREF, OUTLET_BADGE_LABEL);
		if ( quantity == 0 ) {
			$('<div class="outletSoldoutPanel clickAction d-flex justify-content-center flex-column" data-href="' + OUTLET_HREF + '"><p class="outletSoldoutLabel align-self-center mb-0 w-100"><strong>' + TXT_OUTLET_NAME + '</strong></p><p class="outletSoldout align-self-center mb-0 w-100"><strong>' + TXT_OUTLET_SOLDOUT + '</strong></p></div>').insertAfter(obj.find('.productAddToCart'));
			obj.find('.productAddToCart').remove();
			that.alertTrigger = true;
		}
		toolsObj.initClickAction();
	}
	// ****************************************************************************************************
	// Dodanie badga z poziomem rabatu
	// ****************************************************************************************************
	addPercentBadge(obj, kth_net, es_netto, addClass, href, label) {
		var that = this;
		var discount = Math.round(100 - ((es_netto * 10000) / (kth_net * 100)));
		if ( DELIVERY_ON_VACATION ) {
			obj.find('.productImgCont').prepend('<div class="badgePanel vac">'
				+'<div class="productBadge TDBadge clickAction ' + addClass + '" data-href="' + href + '"><b class="percent percentB">-' + discount + '%</b>' + label + '</div>'
				+ '<div class="rounded-right p-1 x5 infoDeliveryOnVacations"><a href="' + DELIVERY_ON_VACATION_LINK + '"><img style="width: 75px" src="' + DELIVERY_ON_VACATION_ICO + '" alt="' + DELIVERY_ON_VACATION_TITLE + '" title="' + DELIVERY_ON_VACATION_TITLE + '" /></a></div>'
			+'</div>');
		} else {
			obj.find('.productImgCont').prepend('<div class="badgePanel NoVAC"><div class="productBadge TDBadge clickAction ' + addClass + '" data-href="' + href + '"><b class="percent percentB">-' + discount + '%</b>' + label + '</div></div>');
		}
		toolsObj.initClickAction();
	}
	// ****************************************************************************************************
	// Zdekodowanie inforamcji o wysyłce
	// ****************************************************************************************************
	createShipmentHtml(source, i) {
		var that = this;
		var cfgActualDayOfWeek = Number(source.substr(source.lastIndexOf('data-shipment-actual-day="') + 26, 1));
		var cfgDayOfWeekOfNextShipmentAfterAssembly = Number(source.substr(source.lastIndexOf('data-shipment-assembly-day="') + 28, 1));
		var cfgDayOfWeekOfNextShipment = Number(source.substr(source.lastIndexOf('data-shipment-next-day="') + 24, 1));

		if (SHOW_SHIPMENT_PANEL && that.JSON[that.settings.JSONRoot][i - 1].dostepnosc > 0) {
			var ukryteOdpowiedniki = (that.JSON[that.settings.JSONRoot][i - 1].odpowiedniki2) ? that.JSON[that.settings.JSONRoot][i - 1].odpowiedniki2 : "empty"; // false wysypuje inludes
			if (that.JSON[that.settings.JSONRoot][i - 1].skladniki > 1 && !ukryteOdpowiedniki.includes('wysyłkaDziś')) {
				source = source.replace('$productShipmentClass', 'productShipmentPreparation');
				source = source.replace('$productShipmentTxt', that.decodeShipmentDay(cfgDayOfWeekOfNextShipmentAfterAssembly, cfgActualDayOfWeek));
				source = source.replace('data-shipment-regular="$productNextShipmentTxt"', "");
			}
			else if (SHOW_SHIPMENT_TODAY) {
				source = source.replace('$productShipmentClass', 'productShipmentToday');
				source = source.replace('$productShipmentTxt', that.decodeShipmentDay(0, cfgActualDayOfWeek));
				source = source.replace('$productNextShipmentTxt', that.decodeShipmentDay(cfgDayOfWeekOfNextShipment, cfgActualDayOfWeek));
			}
			else {
				source = source.replace('$productShipmentClass', '');
				source = source.replace('$productShipmentTxt', that.decodeShipmentDay(cfgDayOfWeekOfNextShipment, cfgActualDayOfWeek));
				source = source.replace('data-shipment-regular="$productNextShipmentTxt"', "");
			}
		} else {
			source = source.replace('$productShipmentClass', 'productShipmentEmpty');
			source = source.replace('$productShipmentTxt', '');
			source = source.replace('data-shipment-regular="$productNextShipmentTxt"', "");
		}
		return source;
	}
	// ****************************************************************************************************
	// Zdekodowanie Tekstu opisującego dzień wysyłki
	// ****************************************************************************************************
	decodeShipmentDay(day_no, cfgActualDayOfWeek) {
		var tomorrow = (cfgActualDayOfWeek + 1) % 7;
		if (day_no == tomorrow)
			return TXT_SHIPMENT_TOMORROW;
		else if (day_no < 6)
			return TXT_SHIPMENT[day_no];
		else
			return "";
	}
	// ****************************************************************************************************
	// Zdekodowanie ceny
	// ****************************************************************************************************
	createPriceHtml(i) {
		let that = this;
		let html = '';
		let cena_kth_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_netto;
		let cena_kth_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_brutto;
		let cena_es_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto;
		let cena_es_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_brutto;

		if ( that.settings.showPromoPrice ) {
			html = html + '<p class="regularPrice text-center mb-2">';
			html = html + '<span class="price delParent"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_netto) + '</del> ' + NET_ADDON + '</span>';
			if ( SHOW_GROSS_VALUE && ( cena_kth_netto != cena_kth_brutto ) )
				html = html + '<br><span class="price delParent"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_brutto) + '</del> ' + GROSS_ADDON + '</span>';
			html = html + '</p>';
		}

		html = html + '<p class="text-center mb-0">';
		html = html + '<span class="price"><strong>' + toolsObj.formatPrice(cena_es_netto) + '</strong> ' + NET_ADDON + '</span>';
		if ( SHOW_GROSS_VALUE && ( cena_es_netto != cena_es_brutto ) )
			html = html + '<br><span class="price"><strong>' + toolsObj.formatPrice(cena_es_brutto) + '</strong> ' + GROSS_ADDON + '</span>';
		html = html + '</p>';
		return html;
	}
	// ****************************************************************************************************
	// Zdekodowanie ceny JOKER
	// ****************************************************************************************************
	createJokerPriceHtml(i) {
		var that = this;
		var html = '';
		let cena_przed_jokerem_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_przed_jokerem_netto;
		let cena_przed_jokerem_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_przed_jokerem_brutto;
		let cena_es_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto;
		let cena_es_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_brutto;

		html = html + '<p class="jokerPrice text-center mb-0">';
		html = html + '<span class="price delParent"><del class="delPrice">' + toolsObj.formatPrice(cena_przed_jokerem_netto) + '</del> ' + NET_ADDON + '</span><br>';
		if ( SHOW_GROSS_VALUE && cena_przed_jokerem_netto != cena_przed_jokerem_brutto ) {
			html = html + '<span class="price delParent"><del class="delPrice">' + toolsObj.formatPrice(cena_przed_jokerem_brutto) + '</del> ' + GROSS_ADDON + '</span>';
		}
		html = html + '</p>';
		html = html + '<p class="jokerPrice text-center mb-0 mt-2">';
		html = html + '<span class="price grossPrice" style="color: ' + JOKER_TXT_COLOR + '; background-color: ' + JOKER_BG_COLOR + ';"><strong>' + toolsObj.formatPrice(cena_es_netto) + '</strong> ' + NET_ADDON + '</span><br>';
		if ( SHOW_GROSS_VALUE && cena_es_netto != cena_es_brutto ) {
			html = html + '<span class="price grossPrice" style="color: ' + JOKER_TXT_COLOR + '; background-color: ' + JOKER_BG_COLOR + ';"><strong>' + toolsObj.formatPrice(cena_es_brutto) + '</strong> ' + GROSS_ADDON + '</span>';
		}
		html = html + '</p>';

		/* 11.12.2020 - modyfikacja jokerów
		html = html + '<div class="jokerBadge text-center mt-3">'+
			'<img src="' + JOKER_IMG + '" title="' + JOKER_TITLE + '"/>'+
			'<p class="h3 mt-1"><span style="color: ' + JOKER_TXT_COLOR + '; background-color: ' + JOKER_BG_COLOR + ';">' + JOKER_TITLE + '</span></p>'+
		'</div>';
		*/
		return html;
	}
	// ****************************************************************************************************
	// Zdekodowanie ceny PRO
	// ****************************************************************************************************
	createPromoPriceHtml(i) {
		var that = this;
		var html = '';
		let cena_kth_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_netto;
		let cena_kth_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_brutto;
		let cena_es_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto;
		let cena_es_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_brutto;

		let id = that.JSON[that.settings.JSONRoot][i - 1].id;
		let cena_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_netto;
		let cena_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_brutto;
		let cena_es_typ = that.JSON[that.settings.JSONRoot][i - 1].cena_es_typ;
		let promo_id = that.JSON[that.settings.JSONRoot][i - 1].promo_id;

		html += '<p class="promoPrice text-center mb-0 mt-2">';
		html += '<span class="price"><strong>' + toolsObj.formatPrice(cena_es_netto) + '</strong> ' + NET_ADDON + '</span><br>';
		if ( SHOW_GROSS_VALUE && cena_es_netto != cena_es_brutto ) {
			html += '<span class="price"><strong>' + toolsObj.formatPrice(cena_es_brutto) + '</strong> ' + GROSS_ADDON + '</span>';
		}
		html += '</p>';

		html += '<p class="priceInfo text-center mb-0 mt-2">';
		if ( SHOW_GROSS_VALUE && cena_kth_netto != cena_kth_brutto && !SHOW_NET_PRICE ) {
			html += REGULAR_PRICE_TXT + ' <span class="price delParent text-nowrap"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_brutto) + '</del> ' + GROSS_ADDON + '</span>';
		} else {
			html += REGULAR_PRICE_TXT + ' <span class="price delParent text-nowrap"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_netto) + '</del> ' + NET_ADDON + '</span><br>';
		}
		html += '</p>';

		if ( SHOW_HISTORY_PRICE_MAINPAGE ) {
			html += '<p class="historyPrice mb-0"">';
			html += LOWEST_PRICE_TXT + ' <span id="last30days_' + that.settings.pviModuleID + '_' + id + '" class="position-relative" style="white-space: nowrap;"> <span class="spinner-border spinner-border-sm position-absolute" role="status" style="top: 0.25rem; left: .25rem;"></span></span>';
			html += '</p>';

			if ( SHOW_GROSS_VALUE && cena_kth_netto != cena_kth_brutto ) {
				toolsObj.get30DaysPrice(id, CURRENCY, "gross", COUNTRY, cena_es_netto, cena_es_brutto, cena_netto, cena_brutto,cena_es_typ+promo_id, that.settings.pviModuleID + '_' + id);
			} else {
				toolsObj.get30DaysPrice(id, CURRENCY, "net", COUNTRY, cena_es_netto, cena_es_brutto, cena_netto, cena_brutto,cena_es_typ+promo_id, that.settings.pviModuleID + '_' + id);
			}
		}

		return html;
	}
	// ****************************************************************************************************
	// Zdekodowanie ceny BRUNETTO
	// ****************************************************************************************************
	createBrunettoPriceHtml(i) {
		var that = this;
		var html = '';
		let cena_kth_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_netto;
		let cena_kth_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_brutto;
		let cena_es_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto;
		let cena_es_brutto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_brutto;

		html = html + '<p class="jokerBrunetto text-center mb-0">';
		//wyjątek program antyinflacyjny
		//html = html + '<span class="price grossPrice delParent" style="color: ' + JOKER_TXT_COLOR + '; background-color: ' + JOKER_BG_COLOR + ';"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_netto) + '</del> ' + NET_ADDON + '</span><br>';
		html = html + '<span class="price grossPrice delParent"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_netto) + '</del> ' + NET_ADDON + '</span><br>';
		if ( SHOW_GROSS_VALUE && cena_kth_netto != cena_kth_brutto  ) {
			html = html + '<span class="price grossPrice delParent"><del class="delPrice">' + toolsObj.formatPrice(cena_kth_brutto) + '</del> ' + GROSS_ADDON + '</span>';
		}
		html = html + '</p>';
		html = html + '<p class="jokerBrunetto text-center mb-0 mt-2">';
		html = html + '<span class="price grossPrice"><strong>' + toolsObj.formatPrice(cena_es_netto) + '</strong> ' + NET_ADDON + '</span><br>';
		if ( SHOW_GROSS_VALUE && cena_es_netto != cena_es_brutto ) {
			html = html + '<span class="price grossPrice" style="color: ' + JOKER_TXT_COLOR + '; background-color: ' + JOKER_BG_COLOR + ';"><strong>' + toolsObj.formatPrice(cena_es_brutto) + '</strong> ' + GROSS_ADDON + '</span>';
		}
		html = html + '</p>';

		html = html + '<div class="jokerBadge text-center mt-3">';
		html = html + '<img src="' + JOKER_IMG + '" title="' + BRUNETTO_TITLE + '"/>';
		if ( BRUNETTO_SHOW_TITLE ) {
			html = html + '<p class="h3 mt-1"><span style="color: ' + JOKER_TXT_COLOR + '; background-color: ' + JOKER_BG_COLOR + ';">' + BRUNETTO_TITLE + '</span></p>';
		}
		html = html + '</div>';

		return html;
	}
	// ****************************************************************************************************
	// dodanie badge Jokera
	// ****************************************************************************************************
	addJokerBadge(i) {
		var that = this;
		var badgeHtml = '';
		let pvi = $('#p-' + that.settings.pviModuleID + '-' + that.JSON[that.settings.JSONRoot][i - 1].id );

		if ( that.settings.brunetto )
			return false;

		badgeHtml = badgeHtml + '<div class="productBadge jokerBadge" style="color: ' + JOKER_BG_COLOR + '; background-color: ' + JOKER_TXT_COLOR + ';">';
		badgeHtml = badgeHtml + '<b class="percent percentBJS">-' + JOKER_PROCENT + '%</b>';
		badgeHtml = badgeHtml + '</div>';
		badgeHtml = badgeHtml + '</div>';

		$('#p-' + that.settings.pviModuleID + '-' + that.JSON[that.settings.JSONRoot][i - 1].id + ' .productImgCont').append(badgeHtml);
	}
	// ****************************************************************************************************
	// dodanie badge promocji strefy okazji
	// ****************************************************************************************************
	addSOBadge(i) {
		var that = this;
		var badgeHtml = '';

		badgeHtml = badgeHtml + '<div class="badgePanel">';
		badgeHtml = badgeHtml + '<div class="productBadge '+PROMO_SO_CLASS+' clickAction" data-href="'+PROMO_SO_LINK+'" title="'+PROMO_SO_TITLE+'"><img src="'+PROMO_SO_IMG+'"></div>';
		badgeHtml = badgeHtml + '</div>';
		badgeHtml = badgeHtml + '</div>';

		$('#p-' + that.settings.pviModuleID + '-' + that.JSON[that.settings.JSONRoot][i - 1].id + ' .productImgCont').append(badgeHtml);
	}

	// ****************************************************************************************************
	// dodanie badge z procentem
	// ****************************************************************************************************
	addPercentageBadge(i, cls="TDBadge TDJSBadge", act="/todays-deals") {
		var that = this;
		var badgeHtml = '';

		badgeHtml = badgeHtml + '<div class="badgePanel">';
		//badgeHtml = badgeHtml + '<div class="productBadge '+cls+' clickAction" data-href="'+act+'" title="'+PROMO_TITLE+'">'+that.calculatePromoDiscount(i)+'%</div>';
		badgeHtml = badgeHtml + '<div class="productBadge '+cls+'"><strong>-'+that.calculatePromoDiscount(i)+'%</strong></div>';
		//badgeHtml = badgeHtml + '</div>';

		if ( DELIVERY_ON_VACATION ) {
			badgeHtml = badgeHtml + '<div class="rounded-right p-1 infoDeliveryOnVacations"><a href="' + DELIVERY_ON_VACATION_LINK + '"><img style="width: 75px" src="' + DELIVERY_ON_VACATION_ICO + '" alt="' + DELIVERY_ON_VACATION_TITLE + '" title="' + DELIVERY_ON_VACATION_TITLE + '" /></a></div>';
		}

		badgeHtml = badgeHtml + '</div>';

		$('#p-' + that.settings.pviModuleID + '-' + that.JSON[that.settings.JSONRoot][i - 1].id + ' .productImgCont').append(badgeHtml);
	}
	// ****************************************************************************************************
	// dodanie badge z transportem na urlopie
	// ****************************************************************************************************
	addFreeDeliveryBadge(i, cls="TDBadge TDJSBadge", act="/todays-deals") {
		var that = this;
		var badgeHtml = '';

		badgeHtml = badgeHtml + '<div class="badgePanel">';
		badgeHtml = badgeHtml + '<div class="rounded-right p-1 infoDeliveryOnVacations"><a href="' + DELIVERY_ON_VACATION_LINK + '"><img style="width: 75px" src="' + DELIVERY_ON_VACATION_ICO + '" alt="' + DELIVERY_ON_VACATION_TITLE + '" title="' + DELIVERY_ON_VACATION_TITLE + '" /></a></div>';
		badgeHtml = badgeHtml + '</div>';

		$('#p-' + that.settings.pviModuleID + '-' + that.JSON[that.settings.JSONRoot][i - 1].id + ' .productImgCont').append(badgeHtml);
	}
	// ****************************************************************************************************
	// wyliczenie procentu na podstawie cen
	// ****************************************************************************************************
	calculatePromoDiscount(i) {
		var that = this;
		var discount;
		let cena_kth_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_kth_netto;
		let cena_es_netto = that.JSON[that.settings.JSONRoot][i - 1].cena_es_netto;

		discount = 100 - ( ( cena_es_netto * 100 ) / ( cena_kth_netto ) );
		discount = toolsObj.roundTo(discount, 0);

		if ( discount > 99 )
			discount = 99;

		return discount;
	}
	// ****************************************************************************************************
	// Zdekodowanie dostępności
	// ****************************************************************************************************
	createAvailabilityHtml(i) {
		var that = this;
		if (SHOW_STRICT_AVAILABILITY) {
			return TXT_AVAILABILITY + ' ' + that.JSON[that.settings.JSONRoot][i - 1].stan_mag + ' ' + that.JSON[that.settings.JSONRoot][i - 1].jm;
		} else {
			var prefix = '<span class="d-inline-block pr-1">' + TXT_AVAILABILITY + '</span>';
			if (that.JSON[that.settings.JSONRoot][i - 1].dostepnosc == 0)
				return prefix + '<span class="availabilityCircle availabilityCircleEmpty"></span><span class="availabilityCircle availabilityCircleEmpty"></span><span class="availabilityCircle availabilityCircleEmpty"></span>';
			else if (that.JSON[that.settings.JSONRoot][i - 1].dostepnosc == 1)
				return prefix + '<span class="availabilityCircle availabilityCircleWarning"></span><span class="availabilityCircle availabilityCircleEmpty"></span><span class="availabilityCircle availabilityCircleEmpty"></span>';
			else if (that.JSON[that.settings.JSONRoot][i - 1].dostepnosc == 2)
				return prefix + '<span class="availabilityCircle"></span><span class="availabilityCircle"></span><span class="availabilityCircle availabilityCircleEmpty"></span>';
			else
				return prefix + '<span class="availabilityCircle"></span><span class="availabilityCircle"></span><span class="availabilityCircle"></span>';
		}
	}
	// ****************************************************************************************************
	// Uruchomienie licznika wysyłki
	// ****************************************************************************************************
	createShipmentCounter() {
		var that = this;
		$('#countDownShipmentTime').removeClass('d-none').hideUp();
		toolsObj.addShipmentCounter('#countDownShipmentTime', '#shipmentTime');
		$('#countDownShipmentTime').showDown(EFFECTS_SPEED);
	}
}
